import { render, staticRenderFns } from "./check-email.vue?vue&type=template&id=33a5c21a&"
import script from "./check-email.vue?vue&type=script&lang=js&"
export * from "./check-email.vue?vue&type=script&lang=js&"
import style0 from "./check-email.vue?vue&type=style&index=0&id=33a5c21a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports